import {
    pendingTask,
    begin,
    end,
} from 'react-redux-spinner';
import { toastr } from 'react-redux-toastr';
import { push } from 'redux-first-history';
import { LOADING_START, LOADING_END } from '../../../store/loading';
import { UPDATE_BID_SELECTION_TEMPLATE } from './bidSelectionTemplate.actions';
import { UPDATE_EMPLOYEE_BIDDABLE_PROFILE } from '../bidProfile/bidProfile.actions';
import * as api from '../../services/api-endpoints';
import { setInitSelectionValues } from '../../../store/bidSelection';
import i18n from '../../../services/i18n';

/**
 * @param {string[]} selection
 * @returns {EmployeeBidSelection.IPreferentialBidSelection} parsedSelection
 */
const bidSelectionToMap = (selection) => {
    /** @type {EmployeeBidSelection.IPreferentialBidSelection} */
    const parsedSelection = {};
    selection.forEach((value, index) => {
        parsedSelection[index + 1] = value;
    });
    return parsedSelection;
};

/**
 * @param {string} profileId
 */
// eslint-disable-next-line import/prefer-default-export
export const selectBidSelectionTemplate = (profileId) => /** @param {import('redux').Dispatch} dispatch */ async (dispatch) => {
    try {
        dispatch({ type: LOADING_START, [pendingTask]: begin });
        const result = await api.loadBidSelectionTemplate(profileId);
        if (result.status === 200) {
            const bidSelectionTemplate = result.data;
            // @ts-ignore
            dispatch(setInitSelectionValues(
                bidSelectionTemplate.items,
                bidSelectionTemplate.selectionDetails.preferentialSelection,
                bidSelectionTemplate.anchorDay,
                bidSelectionTemplate.scheduleSource,
                bidSelectionTemplate.shifts,
                bidSelectionTemplate.paycodes,
                bidSelectionTemplate.dayCount,
                bidSelectionTemplate.periodType,
                null,
                bidSelectionTemplate.isGroupShiftlinesWithSameSchedules,
            ));

            dispatch({
                type: UPDATE_BID_SELECTION_TEMPLATE,
                payload: {
                    ...bidSelectionTemplate,
                },
            });
            
            dispatch({
                type: UPDATE_EMPLOYEE_BIDDABLE_PROFILE,
                payload: {
                    isGroupShiftlinesWithSameSchedules: bidSelectionTemplate.isGroupShiftlinesWithSameSchedules,
                },
            });

            dispatch(push('/Employee/template'));
        } else {
            toastr.error(i18n.t('shiftBidding:toastr.fetchingBidSummaryInformation'), i18n.t('shiftBidding:toastr.failedToFetchBidSummaryInformation'));
        }
    } catch (error) {
        toastr.error(i18n.t('shiftBidding:toastr.fetchingBidSummaryInformation'), error.response.data.Message);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};

/**
 * @param {string} profileId
 * @param {string[]} employeeSelections
 */
// eslint-disable-next-line max-len
export const saveBidSelectionTemplate = (profileId, employeeSelections) => /** @param {import('redux').Dispatch} dispatch */ async (dispatch) => {
    try {
        dispatch({ type: LOADING_START, [pendingTask]: begin });
        if (!employeeSelections.length) {
            toastr.error(i18n.t('shiftBidding:toastr.savingTemplate'), i18n.t('shiftBidding:toastr.pleaseChooseAtLeastOneSelection'));
            return;
        }
        const response = await api.saveBidSelectionTemplate(profileId, { selections: bidSelectionToMap(employeeSelections) });
        if (response.status === 200) {
            toastr.success(i18n.t('shiftBidding:toastr.templateSavedSuccessfully'), '');
        } else {
            toastr.error(i18n.t('shiftBidding:toastr.savingTemplate'), i18n.t('shiftBidding:toastr.failedToSave'));
        }
    } catch (error) {
        toastr.error(i18n.t('shiftBidding:toastr.savingTemplate'), error.response.data.Message);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
